export default "__VITE_ASSET__CXOnsyHU__"